@use "../../styles/mixins/component-wrapper" as wrapper;

@include wrapper.layered-component {
  input,
  .input-body {
    font-family: var(--semantic-font-family-utility);
    font-size: var(--semantic-font-size-utility-m);
    font-style: normal;
    font-weight: var(--semantic-font-weight-utility-default);
    line-height: var(--semantic-line-height-utility-m);
    letter-spacing: var(--semantic-letter-spacing-utility-m);
    color: var(--semantic-color-on-surface-primary-resting);
    background: var(--semantic-color-surface-default-resting);
  }

  .input-body {
    display: flex;
    padding: var(--input-field-inset-vertical) var(--input-field-inset-horizontal);
    align-items: center;
    gap: var(--input-field-gap);
    align-self: stretch;
    border-radius: var(--semantic-border-radius-m);
    border: var(--semantic-border-width-static) solid var(--semantic-color-border-secondary-resting);
    overflow: hidden;
    text-overflow: ellipsis;
    cursor: text;

    .icon {
      font-family: "Allianz Icons"; /* stylelint-disable -- Declaration of custom font. */
      cursor: pointer;

      &.icon-password-hide {
        &:before {
          content: "\ea52";
        }
      }

      &.icon-password-show {
        &:before {
          content: "\ea54";
        }
      }
    }

    &.input-disabled {
      color: var(--semantic-color-on-surface-primary-disabled);
      border: var(--semantic-border-width-static) solid var(--semantic-color-border-secondary-disabled);
      background: var(--semantic-color-surface-default-disabled);
      pointer-events: none;
      cursor: not-allowed;
    }

    &.input-critical {
      border: var(--semantic-border-width-static) solid var(--semantic-color-signal-attention-critical-resting);
    }

    &.input-focused {
      background: var(--semantic-color-surface-default-hover);
      border: var(--semantic-border-width-focus) solid var(--semantic-color-border-focus);
    }

    &.input-readonly {
      color: var(--semantic-color-on-surface-primary-readonly);
      border: var(--semantic-border-width-static) solid var(--semantic-color-border-secondary-disabled);
      background: var(--semantic-color-surface-default-disabled);
      pointer-events: none;
    }
  }

  input {
    border: 0 none;
    padding: 0;
    margin: 0;
    width: 100%;

    &[readonly] {
      color: var(--semantic-color-on-surface-primary-readonly);
      background: var(--semantic-color-surface-default-disabled);
    }

    &[disabled] {
      cursor: not-allowed;
      color: var(--semantic-color-on-surface-primary-disabled);
      background: var(--semantic-color-surface-default-disabled);

      &::placeholder {
        color: var(--semantic-color-on-surface-primary-disabled);
      }
    }

    &:focus {
      outline: none;
      background: var(--semantic-color-surface-default-hover);
    }

    &::placeholder {
      color: var(--semantic-color-on-surface-secondary-resting);
    }
  }

  /* Disable browser-specific styles for password field */
  input::-ms-reveal,
  input::-ms-clear {
    display: none;
  }
}
